var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viewOpeningReportAE" },
    [
      _c("div", { staticClass: "cont-box" }, [
        _c(
          "div",
          { staticClass: "title" },
          [_c("Title", { attrs: { text: "设计撰写", isShowBack: true } })],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  headerRowClassName: "uni-primary-table-header",
                  stripe: "",
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "", align: "center", label: "流程标题" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(row.student_title) +
                                " + " +
                                _vm._s(row.process_title) +
                                " + " +
                                _vm._s(row.created_at)
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sign_img",
                    align: "center",
                    label: "手写签名",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("img", {
                            staticStyle: {
                              width: "200px",
                              height: "40px",
                              "object-fit": "contain",
                            },
                            attrs: { src: row.sign_img, alt: "" },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "design_type_title",
                    align: "center",
                    label: "稿次",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "check_remark",
                    align: "center",
                    label: "状态",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(row.check_status == 1 ? "正常" : "已驳回")
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "check_remark",
                    align: "center",
                    label: "驳回备注",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "teacher_guide",
                    align: "center",
                    label: "指导回复",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          row.teacher_guide,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "QACont" },
                              [
                                _c("span", [_vm._v(_vm._s(index + 1 + "、"))]),
                                _c("span", [_vm._v(_vm._s(item.content))]),
                                (item.files_url ? true : false)
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        JSON.parse(item.files_url),
                                        function (item2, index2) {
                                          return _c(
                                            "p",
                                            { key: index2 },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "file-name" },
                                                [_vm._v(_vm._s(item2.name))]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.downloadFiles(
                                                        item2
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("下载")]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "viewQA",
          attrs: { title: "查看问答", visible: _vm.isShowViewQA, width: "40%" },
          on: {
            "update:visible": function ($event) {
              _vm.isShowViewQA = $event
            },
            close: _vm.viewQAClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _vm.QAList.length > 0
                ? _c(
                    "div",
                    { staticClass: "QA-cont" },
                    [
                      _c(
                        "el-scrollbar",
                        {
                          ref: "viewQAScrollbar",
                          staticStyle: { height: "360px" },
                        },
                        _vm._l(_vm.QAList, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "item" },
                            [
                              item.type == 1
                                ? _c("div", { staticClass: "ask" }, [
                                    _c("div", { staticClass: "top" }, [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(item.student_title)),
                                      ]),
                                      _c("span", { staticClass: "time" }, [
                                        _vm._v(_vm._s(item.created_at)),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "cont" }, [
                                      _c("span", { staticClass: "text" }, [
                                        _vm._v(_vm._s(item.content)),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                              item.type == 2
                                ? _c("div", { staticClass: "answer" }, [
                                    _c("div", { staticClass: "top" }, [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(item.teacher_title)),
                                      ]),
                                      _c("span", { staticClass: "time" }, [
                                        _vm._v(_vm._s(item.created_at)),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "cont" }, [
                                      _c("span", { staticClass: "text" }, [
                                        _vm._v(_vm._s(item.content)),
                                      ]),
                                      (item.files_url ? true : false)
                                        ? _c(
                                            "div",
                                            { staticClass: "imgs-box" },
                                            _vm._l(
                                              JSON.parse(item.files_url),
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "file-name",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "10px",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downloadFiles(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("下载")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  ref: "viewQA",
                  attrs: {
                    model: _vm.viewQAData,
                    rules: _vm.viewQARules,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题内容", prop: "content" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入问题内容",
                          type: "textarea",
                          rows: "3",
                          clearable: "",
                        },
                        model: {
                          value: _vm.viewQAData.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewQAData, "content", $$v)
                          },
                          expression: "viewQAData.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowViewQA = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.viewQASubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }